<template>
	<div class="DeliveryDetail">
		<common-body aside="5">
			<div slot="commonMain" class="quotation_box" v-loading.lock="loadingStatus">
				<div v-if="detail">
					<el-row type="flex" align="middle" justify="space-between" class="quotation_header">
						<el-row type="flex" align="middle" class="location_box">
							<div class="location_icon">
								<i class="el-icon-s-promotion"></i>
							</div>
							<el-row type="flex" align="middle" class="location_text">
								<div>当前位置：</div>
								<el-button @click="goBack" type="text">我的订单</el-button>
								<div class="location_xie">/</div>
								<div>查看详情</div>
							</el-row>
						</el-row>
						<el-row type="flex" align="middle" class="header_r">
							<div @click="printQuotation(2)" class="header_btn header_btn2">打印发货单</div>
						</el-row>
					</el-row>
					<el-form label-position="right" :model="detail" class="quotation_form">
						<div class="detail_info_section">
							<el-tabs v-model="infoTab" type="card" class="detail_info_tabs">
								<el-tab-pane label="发货清单" name="goods">
									<div class="detail_goods_panel">
										<el-row type="flex" justify="space-between" class="quotation_info quotation_info--view">
											<div class="quotation_info_col">
												<div class="info-view-item">
													<div class="info-view-label">
														<span class="info-view-label__text">
															<i v-for="(ch, i) in labelChars('单号')" :key="'a'+i">{{ ch }}</i>
														</span>
													</div>
													<div class="info-view-value">{{ displayText(detail.order_number) }}</div>
												</div>
												<div class="info-view-item info-view-item--address">
													<div class="info-view-label">
														<span class="info-view-label__text">
															<i v-for="(ch, i) in labelChars('收货地址')" :key="'b'+i">{{ ch }}</i>
														</span>
													</div>
													<div class="info-view-value info-view-value--multiline">{{ displayText(detail.receiving_address) }}</div>
												</div>
											</div>
											<div class="quotation_info_col">
												<div class="info-view-item">
													<div class="info-view-label">
														<span class="info-view-label__text">
															<i v-for="(ch, i) in labelChars('客户名称')" :key="'c'+i">{{ ch }}</i>
														</span>
													</div>
													<div class="info-view-value">{{ displayText(detail.customer_id) }}</div>
												</div>
												<div class="info-view-item">
													<div class="info-view-label">
														<span class="info-view-label__text">
															<i v-for="(ch, i) in labelChars('联系人')" :key="'d'+i">{{ ch }}</i>
														</span>
													</div>
													<div class="info-view-value">{{ displayText(detail.contacts) }}</div>
												</div>
												<div class="info-view-item">
													<div class="info-view-label">
														<span class="info-view-label__text">
															<i v-for="(ch, i) in labelChars('联系电话')" :key="'e'+i">{{ ch }}</i>
														</span>
													</div>
													<div class="info-view-value">{{ displayText(detail.contacts_phone) }}</div>
												</div>
											</div>
											<div class="quotation_info_col">
												<div class="info-view-item">
													<div class="info-view-label">
														<span class="info-view-label__text">
															<i v-for="(ch, i) in labelChars('报价日期')" :key="'f'+i">{{ ch }}</i>
														</span>
													</div>
													<div class="info-view-value">{{ displayText(detail.createTime) }}</div>
												</div>
												<div class="info-view-item">
													<div class="info-view-label">
														<span class="info-view-label__text">
															<i v-for="(ch, i) in labelChars('运输方式')" :key="'g'+i">{{ ch }}</i>
														</span>
													</div>
													<div class="info-view-value">{{ displayText(detail.delivery_text) }}</div>
												</div>
												<div class="info-view-item">
													<div class="info-view-label">
														<span class="info-view-label__text">
															<i v-for="(ch, i) in labelChars('发票类型')" :key="'h'+i">{{ ch }}</i>
														</span>
													</div>
													<div class="info-view-value">{{ displayText(detail.invoice_text) }}</div>
												</div>
											</div>
										</el-row>
										<el-table border stripe class="printTable" :data="detail.goodslist" style="width: 100%" cell-class-name="good_text" header-cell-class-name="good_header">
											<el-table-column :resizable="resizeable" align="center" min-width="3%" label="序号">
												<template slot-scope="scope">
													<div>{{scope.$index+1}}</div>
												</template>
											</el-table-column>
											<el-table-column :resizable="resizeable" align="center" min-width="10%" label="名称">
												<template slot-scope="scope">
													<el-popover
														placement="top"
														trigger="hover"
														:open-delay="2000"
														popper-class="delivery-good-popover">
														<div class="good_reference">
															<img :src="scope.row.sku_image_text" />
														</div>
														<div slot="reference" class="good_name">{{ cartDisplayName(scope.row) }}</div>
													</el-popover>
												</template>
											</el-table-column>
											<el-table-column v-if="detail.category!=13&&detail.category!=19&&detail.category!=29&&detail.category!=30&&detail.category!=31&&detail.category!=40&&detail.category!=43&&detail.category!=45" :resizable="resizeable" align="center" min-width="12%" label="尺寸(mm)">
												<template slot-scope="scope">
													<div class="good_size">
														<div v-if="scope.row.goods_valuation==1">-</div>
														<div v-else>{{ formatSizeText(scope.row.size_text) }}</div>
													</div>
												</template>
											</el-table-column>
											<el-table-column :resizable="resizeable" align="center" min-width="12%" label="规格参数">
												<template slot-scope="scope">
													<div class="good_size">{{ scope.row.parameter_text }}</div>
												</template>
											</el-table-column>
											<el-table-column v-if="detail.category==20||detail.category==25||detail.category==26||detail.category==27||detail.category==28||detail.category==32||detail.category==33||detail.category==44" :resizable="resizeable" align="center" min-width="4%" prop="goods_areas" label="面积(㎡)">
											</el-table-column>
											<el-table-column :resizable="resizeable" align="center" min-width="4%" prop="goods_unit" label="单位">
											</el-table-column>
											<el-table-column :resizable="resizeable" align="center" min-width="4%" prop="goods_num" label="数量">
											</el-table-column>
											<el-table-column :resizable="resizeable" align="center" min-width="10%" label="备注" class-name="print-col-remark" header-class-name="print-col-remark">
												<template slot-scope="scope">
													<div class="good_remark_text">{{ scope.row.remarks == '' ? '无' : scope.row.remarks }}</div>
												</template>
											</el-table-column>
										</el-table>
										<div class="goods_footer">
											<div class="goods_footer_item goods_footer_item--remark">
												<div class="goods_footer_remark_block">
													<div class="goods_footer_remark_row">
														<div class="goods_footer_remark_label">订单备注：</div>
														<div class="goods_footer_remark_content">{{ detail.remarks || ' ' }}</div>
													</div>
													<div class="goods_footer_text goods_footer_maker">制单人：{{ detail.user_name }}</div>
												</div>
											</div>
										</div>
									</div>
								</el-tab-pane>
								<el-tab-pane label="订单信息" name="order">
									<div class="detail_order_panel">
										<div class="detail_info_panel detail_info_panel--logistics">
											<el-form :rules="logisticsRules" ref="deliverForm" label-position="left" label-suffix="" :model="deliverForm" class="deliver_form logistics_form">
												<div class="logistics-form-row logistics-form-row--status">
													<div class="logistics-form-label">状态：</div>
													<div class="logistics-form-content logistics-form-content--status">
														<template v-if="canEditLogistics">
															<div class="logistics-status-layout">
																<el-radio-group v-model="deliverForm.logistics_status" class="logistics-status-group">
																	<div class="logistics-status-option">
																		<el-radio label="1">未发货</el-radio>
																	</div>
																	<div class="logistics-status-option">
																		<el-radio label="2">已发货</el-radio>
																	</div>
																</el-radio-group>
																<el-form-item
																	class="logistics-info-item"
																	:class="{'logistics-info-item--hidden': deliverForm.logistics_status !== '2'}"
																	label="物流信息"
																	prop="order_sn">
																	<el-input
																		type="textarea"
																		resize="none"
																		:clearable="clearable"
																		placeholder="请输入物流信息"
																		v-model="deliverForm.order_sn"></el-input>
																</el-form-item>
															</div>
														</template>
														<div v-else class="logistics-status-layout logistics-status-layout--readonly">
															<div class="logistics-status-readonly">
																<div class="logistics-status-option">
																	<span class="logistics-status-readonly-item" :class="{'is-active': deliverForm.logistics_status === '1'}">未发货</span>
																</div>
																<div class="logistics-status-option">
																	<span class="logistics-status-readonly-item" :class="{'is-active': deliverForm.logistics_status === '2'}">已发货</span>
																</div>
															</div>
															<div
																class="logistics-info-readonly"
																:class="{'logistics-info-readonly--hidden': deliverForm.logistics_status !== '2'}">
																<div class="logistics-info-readonly-label logistics-info-vertical-label">物流信息</div>
																<div class="logistics-info-readonly-value">{{ displayText(deliverForm.order_sn) }}</div>
															</div>
														</div>
													</div>
												</div>
												<div class="logistics-form-row logistics-form-row--files">
													<div class="logistics-form-label">附件：</div>
													<div class="logistics-form-content logistics-form-content--files">
														<imageUpload
															v-if="canEditLogistics"
															v-model="deliverForm.logistics_files"
															:limit="uploadLimit"
															:multiple="true"
															:fileType="fileType"
															compact
															:cell-size="72" />
														<div v-else-if="logisticsFileList.length" class="logistics-file-preview">
															<div
																v-for="(file, index) in logisticsFileList"
																:key="index"
																class="logistics-file-item"
																@click="previewLogisticsFile(file)">
																<el-image v-if="file.isImage" :src="file.url" fit="cover">
																	<div slot="error" class="logistics-file-fallback">
																		<i class="el-icon-document"></i>
																	</div>
																</el-image>
																<div v-else class="logistics-file-fallback">
																	<i class="el-icon-document"></i>
																</div>
															</div>
														</div>
														<span v-else class="logistics-empty-text">—</span>
													</div>
												</div>
												<div class="logistics-form-row logistics-form-row--deliver">
													<div class="logistics-form-label">发货人：</div>
													<div class="logistics-form-content logistics-form-content--deliver">
														<el-radio-group
															v-if="canEditLogistics"
															v-model="deliverForm.deliver"
															class="logistics-deliver-group">
															<el-radio
																v-for="name in deliverOptions"
																:key="name"
																:label="name">{{ name }}</el-radio>
														</el-radio-group>
														<div v-else class="logistics-deliver-readonly">{{ displayText(shipperName) }}</div>
													</div>
												</div>
												<div class="logistics-form-row logistics-form-row--operator">
													<div class="logistics-form-label">操作人：</div>
													<div class="logistics-form-content logistics-form-content--deliver">
														<div class="logistics-deliver-line">
															<div v-if="operatorDisplayName" class="logistics-deliver-readonly">{{ operatorDisplayName }}</div>
															<div v-if="canEditLogistics" class="deliver_btn" @click="submitForm('deliverForm')">保存</div>
															<div v-else-if="showLogisticsModifyBtn" class="deliver_btn deliver_btn--modify" @click="enableLogisticsEdit">修改</div>
														</div>
													</div>
												</div>
											</el-form>
										</div>
									</div>
								</el-tab-pane>
							</el-tabs>
						</div>
					</el-form>
				</div>
			</div>
		</common-body>
		<el-dialog title="附件预览" :visible.sync="logisticsPreviewVisible" width="800px" append-to-body>
			<img v-if="logisticsPreviewUrl" :src="logisticsPreviewUrl" class="logistics-preview-image" />
		</el-dialog>
	</div>
</template>

<script>
	import ImageUpload from '@/components/ImageUpload'
	import {
		accMul,
		getT
	} from "../assets/js/public.js"
	import { cartDisplayName } from '@/utils/cart-display'
	const CDN_BASE = (process.env.CDN_BASE || 'http://127.0.0.1:19000/baojia-system').replace(/\/$/, '')
	const IMAGE_EXT = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp']
	export default {
		name: 'DeliveryDetail',
		components: {
			ImageUpload
		},
		data() {
			return {
				offer_id: 7,
				userInfo: JSON.parse(localStorage.getItem('userInfo')),
				readonly: !0,
				clearable: !0,
				resizeable: !1,
				border: !0,
				loadingStatus: !0,
				detail: null,
				infoTab: 'goods',
				deliveryStatus: !1,
				deliverForm: {
					id: 7,
					order_sn: "",
					deliver: "",
					logistics_status: '1',
					logistics_files: ""
				},
				deliverOptions: ['陈丽君', '李明娣'],
				uploadLimit: 9,
				fileType: ["jpg", "jpeg", "png", "pdf", "dxf", "dws", "dwg"],
				logisticsPreviewVisible: !1,
				logisticsPreviewUrl: '',
				logisticsEditMode: !1,
			}
		},
		beforeRouteLeave(to,from,next) {
			if(to.name === 'Delivery'){
				to.meta.keepAlive = !0
			}
			next()
		},
		created() {
			this.reload();
		},
		watch: {
			'deliverForm.logistics_status'(val, oldVal) {
				if (val !== '2' && this.$refs.deliverForm) {
					this.$refs.deliverForm.clearValidate('order_sn')
				}
				if (val === '1' && oldVal === '2') {
					this.deliverForm.order_sn = ''
					this.deliverForm.logistics_files = ''
					this.deliverForm.deliver = ''
				}
			}
		},
		computed: {
			canEditLogistics() {
				return this.detail && (String(this.detail.status) === '1' || this.logisticsEditMode)
			},
			showLogisticsModifyBtn() {
				return this.detail && String(this.detail.status) === '2' && !this.logisticsEditMode
			},
			/** 已保存的发货人（只读态） */
			shipperName() {
				return (this.detail && this.detail.deliver) || ''
			},
			/** 当前账号昵称（保存时写入操作记录） */
			currentAccountName() {
				const info = this.userInfo || {}
				return String(info.nickname || info.username || '').trim()
			},
			/** 操作记录：编辑中预览当前账号；已发货只读展示当时写入的人；没有则不显示 */
			operatorDisplayName() {
				if (this.canEditLogistics) {
					return this.currentAccountName
				}
				return String((this.detail && this.detail.logistics_operator) || '').trim() || this.currentAccountName
			},
			logisticsRules() {
				const that = this
				return {
					order_sn: [{
						validator(rule, value, callback) {
							if (that.deliverForm.logistics_status === '2' && !(value || '').trim()) {
								callback(new Error('物流信息不能为空'))
								return
							}
							callback()
						},
						trigger: 'blur'
					}]
				}
			},
			logisticsFileList() {
				return this.parseLogisticsFiles(this.deliverForm.logistics_files)
			}
		},
		methods: {
			cartDisplayName,
			displayText(val) {
				return val !== undefined && val !== null && val !== '' ? val : '—'
			},
			labelChars(text) {
				return Array.from(String(text || ''))
			},
			formatSizeText(text) {
				if (text === undefined || text === null || text === '' || text === '-') return text
				return String(text).replace(/长/g, '')
			},
			resolveFileUrl(path) {
				if (!path) return ''
				if (/^https?:\/\//i.test(path)) return path
				return CDN_BASE + (path.startsWith('/') ? path : '/' + path)
			},
			parseLogisticsFiles(value) {
				if (!value) return []
				const list = Array.isArray(value) ? value : String(value).split(',')
				return list.map((item) => {
					const path = String(item || '').trim()
					if (!path) return null
					const ext = path.split('.').pop().toLowerCase()
					return {
						path,
						url: this.resolveFileUrl(path),
						isImage: IMAGE_EXT.indexOf(ext) > -1
					}
				}).filter(Boolean)
			},
			previewLogisticsFile(file) {
				if (!file) return
				if (file.isImage) {
					this.logisticsPreviewUrl = file.url
					this.logisticsPreviewVisible = !0
					return
				}
				window.open(file.url, '_blank')
			},
			syncDeliverForm(detail) {
				const isShipped = String(detail.status) === '2'
				this.deliverForm.logistics_status = isShipped ? '2' : '1'
				if (isShipped) {
					this.deliverForm.order_sn = detail.order_sn || ''
					this.deliverForm.logistics_files = detail.logistics_files || ''
					const deliver = detail.deliver || ''
					if (this.logisticsEditMode) {
						this.deliverForm.deliver = this.deliverOptions.indexOf(deliver) > -1 ? deliver : ''
					} else {
						this.deliverForm.deliver = deliver
					}
				} else {
					this.deliverForm.order_sn = ''
					this.deliverForm.logistics_files = ''
					this.deliverForm.deliver = ''
				}
			},
			enableLogisticsEdit() {
				this.logisticsEditMode = !0
				const deliver = (this.detail && this.detail.deliver) || ''
				this.deliverForm.deliver = this.deliverOptions.indexOf(deliver) > -1 ? deliver : ''
				this.$nextTick(() => {
					if (this.$refs.deliverForm) this.$refs.deliverForm.clearValidate()
				})
			},
			reload() {
				let that = this
				that.offer_id = that.$route.query.id,that.deliverForm.id = that.$route.query.id, that.getDetail()
			},
			getDetail() {
				let that = this
				that.$fetch('addons/hlm/api.Order/getOderDetails', {
					id: that.offer_id
				}).then(function(res) {
					console.log(res)
					if (res.code == 1) {
						let detail = res.data
						detail.createTime = getT(detail.offertime*1000),detail.sendTime = getT(detail.sendtime*1000)
						detail.goodslist.forEach((item,index)=>{
							let val = item.goods_valuation, total = 0
							if (val == 1 || val == 3) {
								total = accMul(item.goods_num, parseFloat(item.goods_price))
							} else if (val == 2) {
								total = accMul(accMul(item.goods_num, parseFloat(item.goods_price)), parseFloat(item.goods_size) / 1000)
							} else if (val == 4 || val == 5) {
								total = accMul(accMul(item.goods_num, parseFloat(item.goods_price)), parseFloat(item.goods_areas)/1000000)
							}
							item.goods_areas = parseFloat(item.goods_areas)/1000000
							item.goods_total = 0<total<0.01 ? 0.01 : Math.floor(total * 100) / 100
						})
						that.detail = detail, that.loadingStatus = !1
						that.syncDeliverForm(detail)
					}
				}).catch(function(error) {
					console.log(error)
				})
			},
			delOffer() {
				let that = this
				that.$confirm('此操作将永久删除该单据, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					that.$fetch('addons/hlm/api.order/del', {
						id: that.offer_id
					}).then(function(res) {
						console.log(res)
						if (res.code == 1) {
							that.detailStatus = !1, that.$message({
								message: '删除成功',
								type: 'success',
								duration: 1500,
								center: !0,
								onClose() {
									that.$router.goBack()
								}
							})
						}
					}).catch(function(error) {
						console.log(error)
					})
				}).catch(() => {
					that.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			submitForm(deliverForm) {
				let that = this
				if (that.deliveryStatus) return
				that.$refs[deliverForm].validate((valid) => {
					if (valid) {
						that.deliveryStatus = !0
						const shipped = that.deliverForm.logistics_status === '2'
						that.$fetch('addons/hlm/api.Order/addLogistics', {
							id: that.deliverForm.id,
							order_sn: shipped ? that.deliverForm.order_sn : '',
							deliver: shipped ? that.deliverForm.deliver : '',
							logistics_operator: shipped ? that.currentAccountName : '',
							shipped: shipped ? 1 : 0,
							logistics_files: shipped ? that.deliverForm.logistics_files : ''
						}).then(function(res) {
							console.log(res)
							if (res.code == 1) {
								that.logisticsEditMode = !1
								that.$message({
									message: '保存成功',
									type: 'success',
									duration: 1500,
									center: !0,
									onClose() {
										that.getDetail()
									}
								});
								that.deliveryStatus = !1
							} else {
								that.deliveryStatus = !1
							}
						}).catch(function(error) {
							console.log(error)
							that.deliveryStatus = !1
						})
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			printQuotation(e) {
				let that = this
				that.$router.push(`/print?id=${that.offer_id}&status=${e}`)
			},
			printInvoice() {
				let that = this
			},
			goBack(){
				this.$router.back()
			}
		}
	};
</script>

<style src='../assets/css/deliveryDetail.css'>
	/* px2rem能正常转换 */
</style>
